import { getFromServerTopic } from "@utility/slice";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GENERAL_ERROR, generatingMessage, IDLE, LOADING } from "@constants";

const SLICE = "tenantBilling";

const action = (name) => `${SLICE}/${name}`;

export const getFromServer = (action, contextOptionsFn, payloadFn) =>
  getFromServerTopic({ topic: SLICE, action, contextOptionsFn, payloadFn });

export const getReportDetails = getFromServer(
  "getReportDetails",
  ({ arg }) => arg,
);

export const generateTenantBills = getFromServer(
  "generateTenantBills",
  ({ arg }) => arg,
);

export const initializeViewHistoryPage = getFromServer(
  "initializeViewHistoryPage",
  ({ arg }) => arg,
);

const performHideReport = getFromServer("hideReport", ({ arg }) => arg);

export const hideReport = createAsyncThunk(
  action("hideReport"),
  async (arg, { dispatch }) => {
    await dispatch(performHideReport(arg));
    return dispatch(initializeViewHistoryPage(arg));
  },
);

const performUnlockReport = getFromServer("unlockReport", ({ arg }) => arg);

export const unlockReport = createAsyncThunk(
  action("unlockReport"),
  async (arg, { dispatch }) => {
    await dispatch(performUnlockReport(arg));
    return dispatch(initializeViewHistoryPage(arg));
  },
);

export const slice = createSlice({
  name: SLICE,
  initialState: {
    buildingData: {},
    reportsById: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(generateTenantBills.pending, (state, action) => {
        const { meta } = action;
        const { siteId } = meta.arg;

        const forBuilding = state.buildingData[siteId];
        forBuilding.errorMessage = "";
        forBuilding.message = "";
      })
      .addCase(generateTenantBills.fulfilled, (state, action) => {
        const { meta } = action;
        const { siteId } = meta.arg;

        const forBuilding = state.buildingData[siteId];
        forBuilding.errorMessage = "";
        forBuilding.message = generatingMessage("bill");
      })
      .addCase(generateTenantBills.rejected, (state, action) => {
        const { meta } = action;
        const { siteId } = meta.arg;

        const forBuilding = state.buildingData[siteId];
        forBuilding.message = "";
        forBuilding.errorMessage = GENERAL_ERROR;
      })
      .addCase(getReportDetails.fulfilled, (state, action) => {
        const { meta } = action;
        const { reportId } = meta.arg;
        state.reportsById[reportId] = action.payload.response;
      })
      .addCase(initializeViewHistoryPage.pending, (state, action) => {
        const { meta } = action;
        const { siteId } = meta.arg;

        state.buildingData[siteId] = {
          status: LOADING,
        };
      })
      .addCase(initializeViewHistoryPage.fulfilled, (state, action) => {
        const { meta, payload } = action;
        const { siteId } = meta.arg;
        const { response } = payload;
        const { reportSummaries, tenantOverview, year, years } = response;

        state.buildingData[siteId] = {
          ...state.buildingData[siteId],
          reportSummaries,
          tenantOverview,
          status: IDLE,
          year,
          years,
        };
      });
  },
});

export const {} = slice.actions;

export default slice.reducer;
